
		export default class PageState{
			//模板生成============================================================================
			self:any = null;
			title: string = "";
			ww_token: string = ""
			vipInfo: any = '';
			source:string = ""
			//============================================================================
		}
